<template>
  <div class="mobile-registercss">
    <div style="width:94%;max-width: 500px;background-color: #ffffff;margin-top: 7vh;"
         v-loading="loging">
      <div style="display:flex;align-items:center;justify-content:center;">
        <img :src="bath_path+'img/logo_108.png'"
             style="width: 38px;" />
        <div style="font-size: 38px;letter-spacing: 1px;font-weight: 500;color: #42c3af;margin-left: 8px;">薪火数据</div>
      </div>
      <div style="margin-top: 50px;padding: 30px 0;">
        <div style="display:flex;align-items:flex-end;justify-content:center;">
          <div class="tab-bar-item">欢迎注册</div>
        </div>
        <div class="input-form">
          <el-form ref="userInfo"
                   class="myform"
                   :model="userInfo"
                   :rules="formRules">
            <el-form-item prop="phone">
              <el-input v-model="userInfo.phone"
                        @keyup.enter.native="$refs.pass.focus()"
                        placeholder="请输入手机号码">
                <i slot="prefix"
                   class="el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="userInfo.password"
                        show-password
                        ref="pass"
                        @keyup.enter.native="$refs.pass2.focus()"
                        auto-complete="new-password"
                        placeholder="请输入密码">
                <i slot="prefix"
                   class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password2">
              <el-input v-model="userInfo.password2"
                        show-password
                        ref="pass2"
                        @keyup.enter.native="$refs.yzm.focus()"
                        auto-complete="new-password"
                        placeholder="请再次输入密码">
                <i slot="prefix"
                   class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="username">
                    <el-input v-model="userInfo.username"
                              ref="username"
                              @keyup.enter.native="$refs.email.focus()"
                              placeholder="请输入您的姓名">
                      <i slot="prefix"
                         class="el-icon-user"></i>
                    </el-input>
                  </el-form-item> -->
            <!-- <el-form-item prop="email">
                    <el-input v-model="userInfo.email"
                              ref="email"
                              @keyup.enter.native="$refs[companyDisabled?'pass':'company'].focus()"
                              placeholder="请输入您的邮箱地址">
                      <i slot="prefix"
                         class="iconfont icon-youxiang"></i>
                    </el-input>
                  </el-form-item> -->
            <!-- <el-form-item prop="company">
                    <el-input v-model="userInfo.company"
                              ref="company"
                              @keyup.enter.native="$refs.pass.focus()"
                              :disabled="companyDisabled"
                              placeholder="请输入您的企业名称">
                      <i slot="prefix"
                         class="el-icon-office-building"></i>
                    </el-input>
                  </el-form-item> -->

            <el-form-item prop="yzm">
              <el-input v-model="userInfo.yzm"
                        :maxlength="6"
                        style="width:calc(100% - 135px);"
                        placeholder="请输入验证码">
                <span slot="prefix"
                      style="font-size: 16px;">#</span></el-input>
              <el-button style="margin-left:15px;width:120px;"
                         :disabled="!!mInterval"
                         @click="getYzm()">{{yzmText}}</el-button>
            </el-form-item>
            <el-form-item style="margin-bottom:0px;margin-top:-10px;margin-left: 10px;text-align: left;">
              <el-checkbox v-model="agreement"></el-checkbox>
              <div style="display:inline-block;margin-left:6px;">同意并遵守<a target="_self"
                   rel="noopener noreferrer"
                   href="https://datainside.com.cn/protocol/?mobile=1"
                   class="link">{{'《用户协议》'}}</a>和<a target="_self"
                   href="https://datainside.com.cn/yszc/?mobile=1"
                   rel="noopener noreferrer"
                   class="link">{{'《隐私政策》'}}</a></div>
            </el-form-item>
            <el-form-item style="margin-bottom:10px;">
              <el-button type="primary"
                         :disabled="canRegister"
                         style="width:100%;margin-top:0px;"
                         @click="submitForm()">注册</el-button>
            </el-form-item>
          </el-form>
          <div @click="toLogin"
               class="text-btn">已有账号，立即登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!(/^1(2|3|4|5|6|7|8|9)\d{9}$/.test(value))) {
        callback(new Error('请输入正确的11位手机号'));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      }
      let yz = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,20}$/;
      if (!yz.exec(value)) {
        callback(new Error('密码必须为8-20位数字+字母+特殊字符的组合'));
      } else {
        callback();
      }
    };
    return {
      bath_path: process.env.BASE_URL,
      loading: false,
      wxOpenid: '',//用户的微信id
      uid: '',//分享人的id
      userInfo: {
        username: '',
        phone: '',
        email: '',
        password: '',
        password2: '',
        company: '',
        yzm: ''
      },
      mInterval: '',
      yzmText: '获取验证码',
      formRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validatePhone, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }],
        password2: [{ required: true, message: '请再次输入密码', trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }],
        yzm: [{ required: true, message: '请输入验证码', trigger: 'blur' },
        { len: 6, message: '验证码为6位数字', trigger: 'blur' }],
      },
      agreement: false,
    }
  },
  computed: {
    canRegister () {
      if (this.userInfo.phone && this.userInfo.password && this.userInfo.password2 && this.userInfo.yzm) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    initInterval () {
      let djs = 60;
      this.yzmText = djs + ' s';
      this.mInterval = setInterval(() => {
        djs--;
        if (djs == 0) {
          clearInterval(this.mInterval);
          this.mInterval = null;
          this.yzmText = '获取验证码';
        } else {
          this.yzmText = djs + ' s';
        }
      }, 1000);
    },
    getYzm () {
      if (this.mInterval) return;
      if (this.userInfo.phone == '') {
        this.$message.error('请输入手机号！');
        return;
      }
      this.loading = true;
      let api = 'api/Platform/IntegrationUserAuth/SendNetVerifyCode/';
      let params = {
        phone: this.$aes.encrypt(this.userInfo.phone)
      };
      this.$request.get(api, { params: params })
        .then((response) => {
          this.loading = false;
          if (response.code === '000000') {
            this.$message.info('验证码已发送,注意查收！');
            this.initInterval();
          } else {
            this.$message.info(response.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message.error('验证码获取失败！请稍后重试！');
          this.loading = false;
        });
    },
    toLogin () {
      this.$router.push('/mobilelogin');
    },
    submitForm () {
      this.$refs.userInfo.validate((valid) => {
        if (valid) {
          if (this.agreement) {
            this.submitUserInfo();
          } else {
            this.$message.info('请阅读并同意《用户协议》和《隐私政策》！');
            return false;
          }
        } else {
          return false;
        }
      });
    },
    submitUserInfo () {
      this.loading = true;
      let param = {
        username: this.$aes.encrypt(this.userInfo.username || this.userInfo.phone),
        phone: this.$aes.encrypt(this.userInfo.phone),
        email: this.$aes.encrypt(this.userInfo.email),
        password: this.$aes.encrypt(this.userInfo.password),
        code: this.$aes.encrypt(this.userInfo.yzm),
        company: this.$aes.encrypt(this.userInfo.company || '个人用户'),
        openid: this.$aes.encrypt(this.wxOpenid),
        recommenduid: this.$aes.encrypt(this.uid)
      };
      this.$request.post('api/Platform/IntegrationUserAuth/addUser/', param).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          this.openBIUrl(response.data.links);
        } else {
          this.$message.error(response.message);
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
        });
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url + '?isdialog=1';
      } else {
        alert('没有可使用的系统!');
      }
    }
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}
a.link,
a.link:hover {
  color: #42c3af;
}
a.link:hover {
  text-decoration: underline;
}
.text-btn {
  text-align: center;
  margin-top: 0px;
  font-size: 14px;
  color: #42c3af;
  cursor: pointer;
}
.text-btn:hover {
  text-decoration: underline;
}

.mobile-registercss {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: #ffffff;
  justify-content: center;

  .input-form {
    padding: 20px 20px;
    .myform .el-input__inner {
      letter-spacing: 1px;
      font-size: 14px;
      padding-left: 45px;
      padding-right: 20px;
      border-radius: 25px;
      background-color: #f7f8fa;
    }
    .myform .el-input__prefix {
      left: 20px;
    }
    .myform .el-button {
      border-radius: 25px;
    }
    .myform .el-form-item__error {
      left: 35px;
    }
  }
  .tab-bar-item {
    line-height: 50px;
    font-size: 18px;
    color: #808080;
  }

  .register-box {
    text-align: center;
    padding: 0px 40px;
  }
}
</style>
